export interface IAlertsState {
    message: string,
    visible: boolean;
    type?: string;
}

export enum AlertsActionTypes {
    SHOW_ALERT = '@@alerts/SHOW_ALERT',
    HIDE_ALERT = '@@alerts/HIDE_ALERT',
}